<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-0 text-center" v-text="'Anulowanie subskrypcji'" />
        </template>

        <div class="text-center mb-3">
            <a-icon :icon="summaryVisible ? 'Ok' : 'ErrorCircle'" width="40px" height="40px" />
        </div>

        <h6 v-if="!summaryVisible" v-text="'Czy na pewno chcesz anulować subskrypcję?'" class="text-center" />
        <template v-else>
            <h6
                v-text="`Przyjęliśmy zgłoszenie anulowania subskrypcji.
                Do końca bieżącego miesiąca subskrypcja będzie aktywna.
                1-go dnia kolejnego miesiąca nastąpi jej dezaktywacja.`"
                class="text-center"
            />
            <div class="my-4">
                <div v-for="shop in canceledShops" class="shop-row text-primary" :key="shop.id">
                    <p class="mb-0" v-text="`${shop.full_name}, ${shop.fullAddress}`" />
                </div>
            </div>
        </template>
        <template v-if="!summaryVisible" #footer>
            <the-btn text="Nie, zamknij" class="btn-outline-custom" @click="$emit('close-modal')" />
            <the-btn
                text="Tak, anuluj"
                class="btn-danger"
                :disabled="isLoader"
                :icon="isLoader ? 'Spinner' : ''"
                :is-loading="isLoader"
                :loading-status="isLoader ? 'loading' : 'idle'"
                @click="confirmCancellation"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    data: () => ({
        summaryVisible: false,
        isLoader: false,
        canceledShops: []
    }),

    computed: {
        ...mapGetters('drs', ['getSubscriptionByLocationId', 'getLocations']),

        modalArgs() {
            return this.$store.getters.modalState.args
        },

        selectedShops() {
            return this.modalArgs.selectedShops
        }
    },

    methods: {
        ...mapActions('drs', ['loadSubscriptions']),
        ...mapActions('payment', ['loadUpcomingPayment']),

        confirmCancellation() {
            const promises = this.selectedShops.map(shopId => {
                // TODO: Call the API to cancel the subscription for each selected shop
                return this.$store.$api.delete(`/drs/api/proxy/zor/subscriptions/cancel?bo_location_id=${shopId}`, {
                    params: {
                        service_code: 'KEC'
                    },
                    config: { noCancel: true }
                })
            })

            this.isLoader = true

            Promise.allSettled(promises).then(results => {
                const successfulShopIds = this.selectedShops.filter(
                    (_, index) => results[index].status === 'fulfilled'
                )

                if (!successfulShopIds.length) {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                    return
                }

                // update upcoming payment data
                this.loadUpcomingPayment()

                return this.loadSubscriptions().then(() => {
                    this.canceledShops = successfulShopIds
                        .filter(id => !this.getSubscriptionByLocationId(id))
                        .map(id => this.getLocations.find(loc => loc.id === id))

                    this.summaryVisible = true

                    const failedCount = results.length - successfulShopIds.length

                    if (failedCount > 0) {
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                    }
                })
            }).finally(() => {
                this.isLoader = false
            })
        }
    }
}
</script>